import {
  Dialog, DialogActions,
  DialogContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import {
  Build,
} from "@material-ui/icons";
import MuiButton from "Components/MuiButton/MuiButton";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import React, { useState, useEffect } from "react";
import Translator from "Languages/Utility/Translator";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import { useSetState } from "Helpers/Hooks";
import FactorService from "Services/http/endpoints/factor/FactorService";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import { FACTOR_RESULT } from "Stores/actionTypes";
import priceMask from "Components/Input/components/priceMask";
import NumberDecimalMask from "Components/Input/components/NumberDecimalMask";
import { Alert } from "@material-ui/lab";
import {ReactSVG} from "react-svg";
import infoIcon from "Assets/svg/icon/info.svg";
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';
import * as Icons from 'react-bootstrap-icons';

const ServiceDialog = ({disabled}) => {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { selectedProject, factorResult } = useSelector((state) => ({
    selectedProject: state.project.selectedProject,
    factorResult: state.factor.factorResult,
  }));
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [serviceList, setServiceList] = useState([]);
  const [controls, setControls] = useSetState({
    services: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      col: {
        xs: 12,
        sm: 5,
      },
    },
    value: {
      type: "number",
      value: 0,
      validation: {
        required: true,
      },
      col: {
        xs: 12,
        sm: 3,
      },
    },
    unitPrice: {
      type: "price",
      value: 0,
      validation: {
        required: true,
        isPrice: true,
      },
      col: {
        xs: 12,
        sm: 4,
      },
    },
  });

  const onClear = () => {
    setControls({ services: { value: "" } });
    setControls({ unitPrice: { value: 0 } });
    setControls({ value: { value: 0 } });
    const update = factorResult.ParamKhadamat?.map((item) => {
      return {
        ...item,
        total: item.PriceUnit * item.ValueCalc,
      };
    });
    setServiceList(update);
  };

  const handleDialog = () => setOpenDialog(!openDialog);

  const onEnter = async () => {
    onClear();
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
      };
      const response = await FactorService.getComboKhadamat(data);
      const update = response.data.Value.map((item) => {
        return {
          ...item,
          value: item.Id,
          label: item.Name,
        };
      });
      setControls({ services: { selectItems: update } });
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (controlName === "services") {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProject: selectedProject.Id,
          CheckAll: factorResult.CheckAll,
          ListUnitId: factorResult.ListUnitId,
          Id: value.Id,
        };
        const response = await FactorService.getCalcKhedmat(params);
        setControls({ value: { value: response.data.Value.Calc } });
        setControls({ unitPrice: { value: response.data.Value.PriceUnit } });
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }
  };

  const onFinish = (e) => {
    e.preventDefault();
    const update = serviceList.map((item) => {
      return {
        ...item,
        PriceUnit: item.PriceUnit,
        total: undefined,
      };
    });
    const result = {
      ...factorResult,
      ParamKhadamat: update,
    };
    dispatch({ type: FACTOR_RESULT, factorResult: result });
    handleDialog();
  };
  const onAddToList = () => {
    const newList = [...serviceList];
    const obj = {
      Id: controls.services.value.value,
      Name: controls.services.value.label,
      PriceUnit: controls.unitPrice.value,
      ValueCalc: controls.value.value,
      total: totalPrice,
    };
    setControls({ services: { value: "" } });
    setControls({ unitPrice: { value: 0 } });
    setControls({ value: { value: 0 } });
    newList.push(obj);
    setServiceList(newList);
  };
  const onDelete = async (list) => {
    const newList = serviceList.filter((item) => item.Id !== list.Id);
    setServiceList(newList);
  };
  const onGetOptionDisabled = (option, key) => {
    const list = [...serviceList];
    if (key === "services") {
      return list.some((item) => item.Id === option.value);
    }
  };
  const setValue = (name, value) => {
    setControls({ [name]: { value: value } });
  };

  useEffect(() => {
    if (isNaN(+controls.unitPrice.value)) {
      const price = controls.unitPrice?.value?.replaceAll(",", "");
      const total = +price * +controls.value.value;
      setTotalPrice(total);
    } else {
      const total = +controls.unitPrice?.value * +controls.value.value;
      setTotalPrice(total);
    }
  }, [controls.value, controls.unitPrice]);

  return (
    <>
      <MuiButton
        color="secondary"
        title={<Translator id="services" />}
        onClick={handleDialog}
        disabled={disabled || factorResult.ListUnitId.length === 0}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              <Translator id="services" />
            </p>
          </div>
          <DialogContent>
            <Grid container spacing={1}>
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid item sm={controls[key].col.sm} xs={controls[key].col.xs} key={key + index} >
                    {
                      controls[key].type === "select" &&
                      <MuiAutoComplete
                        getOptionDisabled={(option) => onGetOptionDisabled(option, key) }
                        options={controls[key].selectItems}
                        label={<Translator id={key} />}
                        value={controls[key].value}
                        id={key}
                        onChange={autoCompleteHandler}
                      />
                    }
                    {
                      controls[key].type === "number" &&
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        value={controls[key].value}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type="text"
                        inputComponent={NumberDecimalMask}
                      />
                    }
                    {
                      controls[key].type === "price" &&
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        endIcon={<Translator id='moneyUnit' />}
                        type={controls[key].type}
                      />
                    }
                  </Grid>
                );
              })}
              <Grid item xs={12}>
                <MuiButton
                  loading={loading}
                  disabled={
                    !controls.services.value.value ||
                    controls.value.value === "0"
                  }
                  color="primary"
                  title={
                    <span>
                      {`${t('ezafe_be_list')} (${t('totalPrice')} ${totalPrice.toLocaleString()} ${t('moneyUnit')})`}
                    </span>
                }
                  onClick={onAddToList}
                  fullwidthOnSm
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <List dense={true}>
                {serviceList.map((item, index) => {
                  return (
                    <ListItem key={item.Name + index}>
                      <ListItemIcon>
                        <Build />
                      </ListItemIcon>
                      <ListItemText
                        primary={item.Name}
                        secondary={`${t('value')} : ${item.ValueCalc} - ${t('unitPrice')} : ${item.PriceUnit.toLocaleString()} ${t('moneyUnit')} - ${t('totalPrice')} : ${item.total.toLocaleString()} ${t('moneyUnit')}`}
                      />
                      <ListItemSecondaryAction>
                        <MuiIconButton
                          icon={<Icons.Trash3 size={17} />}
                          className="danger-fill"
                          onClick={() => onDelete(item)}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default ServiceDialog;
